<template>
  <div class="container">
    <div class="navbar">
      <div class="title-container">
        <div class="back" @click="back">
          <img src="@/assets/image/back.png" alt="返回" />
        </div>
        <div class="title">全优能收款</div>
      </div>
    </div>
    <div class="pay pay_SUCCESS">
      <span>支付成功</span>
    </div>
    <div class="k_pay_box">
      <div class="left">
        <span class="left_dec">订单号</span>
      </div>
      <div class="right">
        <span class="right_res">4301324e27387534</span>
      </div>
    </div>
    <div class="k_pay_box">
      <div class="left">
        <span class="left_dec">付款金额</span>
      </div>
      <div class="right">
        <span class="right_res">￥20.00</span>
      </div>
    </div>
    <div class="k_pay_box">
      <div class="left">
        <span class="left_dec">付款时间</span>
      </div>
      <div class="right">
        <span class="right_res">2020年5月7日</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {
      // 返回
      back() {
        this.$router.go(-1);
      },
    }
  }
</script>

<style scoped>
  .container {
    height: 100vh;
    width: 100%;
    position: relative;
    background: #f5f5f5;
  }

</style>



// WEBPACK FOOTER //
// src/pages/success.vue